import { render, staticRenderFns } from "./UserManagementGeneralData.vue?vue&type=template&id=9796d9ee&"
import script from "./UserManagementGeneralData.vue?vue&type=script&lang=js&"
export * from "./UserManagementGeneralData.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementGeneralData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports